import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Table, Form, Icon, Label } from "semantic-ui-react";
import PhotoEditingLabel from "~/models/PhotoEditing/PhotoEditingLabel";
import PromiseButton from "~/components/element/PromiseButton";

const List = observer(({ photoEditingLabels, readOnly, deletePhotoEditingLabelCallback }) => (
  <div>
    {photoEditingLabels.map(photoEditingLabel => (
      <Label key={photoEditingLabel.photoEditingLabelId} style={{ marginBottom: "5px" }}>
        {photoEditingLabel.name}
        {readOnly ? null : (
          <>
            &nbsp;
            <Icon
              name="delete"
              onClick={() => deletePhotoEditingLabelCallback(photoEditingLabel.photoEditingLabelId)}
            />
          </>
        )}
      </Label>
    ))}
  </div>
));

List.propTypes = {
  photoEditingLabels: PropTypes.arrayOf(PropTypes.instanceOf(PhotoEditingLabel)),
  deletePhotoEditingLabelCallback: PropTypes.func.isRequired,
};

const JobLabels = observer(
  ({
    label,
    readOnly,
    disabled,
    photoEditingLabels,
    onLabelChangeCallback,
    deletePhotoEditingLabelCallback,
    addPhotoEditingLabelCallback,
  }) => (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Labels</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {readOnly ? null : (
          <Table.Row>
            <Table.Cell>
              <Form.Input
                fluid
                name="label"
                placeholder="new label"
                style={{ marginBottom: "10px" }}
                value={label}
                disabled={disabled}
                onChange={e => onLabelChangeCallback(e.target.value)}
              />
              <PromiseButton
                disabled={disabled}
                fluid
                basic
                color="green"
                onClick={() => addPhotoEditingLabelCallback()}
              >
                <Icon name="plus" />
                Add Label
              </PromiseButton>
            </Table.Cell>
          </Table.Row>
        )}
        <Table.Row>
          {/* Center the "no labels yet" if there are no labels */}
          <Table.Cell textAlign={photoEditingLabels.length > 0 ? "left" : "center"}>
            {photoEditingLabels.length > 0 ? (
              <List
                readOnly={readOnly}
                photoEditingLabels={photoEditingLabels}
                deletePhotoEditingLabelCallback={photoEditingLabelId =>
                  deletePhotoEditingLabelCallback(photoEditingLabelId)
                }
              />
            ) : (
              <span className="help">no labels yet</span>
            )}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  ),
);

JobLabels.propTypes = {
  label: PropTypes.string,
  // will only show existing labels, form won't be displayed, user can't delete.
  readOnly: PropTypes.bool,
  // Will render form as disabled.
  disabled: PropTypes.bool,
  photoEditingLabels: PropTypes.arrayOf(PropTypes.instanceOf(PhotoEditingLabel)),
  onLabelChangeCallback: PropTypes.func.isRequired,
  deletePhotoEditingLabelCallback: PropTypes.func.isRequired,
  addPhotoEditingLabelCallback: PropTypes.func.isRequired,
};

export default JobLabels;
